import type { SampleRow } from '@geo-admin/shared/contract/api/metrics.ts';
import type { ColumnDef } from '@tanstack/react-table';
import { dateTime, OUTCOME_LABEL } from '../lib/format.ts';
import { PATHS } from '../lib/paths.ts';
import { DataTable } from './data-table.tsx';
import { Badge } from './ui/card.tsx';

const columns: ColumnDef<SampleRow, unknown>[] = [
  { header: '시각', accessorKey: 'createdAt', cell: ({ row }) => dateTime(row.original.createdAt) },
  {
    header: '결과',
    accessorKey: 'outcome',
    cell: ({ row }) => (row.original.outcome ? OUTCOME_LABEL[row.original.outcome] : '진행 중'),
  },
  {
    header: '적격',
    accessorKey: 'eligible',
    cell: ({ row }) => (row.original.eligible ? '✓' : <span className="text-slate-400">제외</span>),
  },
  {
    header: '브랜드 언급',
    accessorKey: 'mentioned',
    cell: ({ row }) =>
      row.original.mentioned ? <Badge tone="green">언급</Badge> : <span className="text-slate-400">—</span>,
  },
  {
    // 「언급」이 아니라 「인용」이다 — 우리 사이트는 인용 URL 로만 잡힌다 (D-09)
    header: '우리 사이트',
    accessorKey: 'ourSiteCited',
    cell: ({ row }) =>
      row.original.ourSiteCited ? <Badge tone="green">인용</Badge> : <span className="text-slate-400">—</span>,
  },
  { header: '인용', accessorKey: 'citations' },
  { header: '장소 카드', accessorKey: 'entities' },
];

/** 질문 상세 「최근 샘플」과 전체 샘플 화면이 함께 쓰는 표 — 운영자 영역 전용 */
export function SampleTable({ samples }: { samples: SampleRow[] }) {
  return (
    <DataTable
      columns={columns}
      data={samples}
      empty="아직 샘플이 없습니다"
      rowLink={(s) => ({ to: PATHS.admin.sample, params: { id: s.id } })}
    />
  );
}
